import useAuth from "@/useAuth";
import publicNavMenuItems from "@/navigation/horizontal";
import adminNavMenuItems from "@/navigation/vertical";
import { i18n } from "@/plugins/i18n";
// import useAdminNotifications from "@/@core/utils/useAdminNotifications";


export default function useMenus() {

    const { tenant, user, userIsAdmin } = useAuth();
    // const { newFeedbackCount } = useAdminNotifications();


    const getTenantTerm = (termKey, tenantTermTranslations, lang) => {

        if (!tenantTermTranslations || !termKey)
            return null;

        if (!tenantTermTranslations[lang])
            return null;

        return tenantTermTranslations[lang][termKey] ?? null;
    }


    const getMenus = (defaultMenuItems) => {
        defaultMenuItems.forEach((menu) => {
            if (menu.dynamicTitle) {
                const tenantTerm = getTenantTerm(
                    menu.dynamicTitleKey,
                    tenant.value.terms?.translations,
                    i18n.locale
                );
                if (tenantTerm) {
                    menu.title = tenantTerm;
                }
            }

            if (menu.children && menu.children.length) {
                menu.children.forEach((child) => {
                    if (child.dynamicTitle) {
                        const tenantChildTerm = getTenantTerm(
                            child.dynamicTitleKey,
                            tenant.value.terms?.translations,
                            i18n.locale
                        );

                        if (tenantChildTerm) {
                            child.title = tenantChildTerm;
                        }
                    }
                });
            }
        });

        return defaultMenuItems.filter((m) => {
            if (user.value.read_only && m.disabled_read_only === true) {
                return false;
            }

            if (m.optional) {
                return tenant.value.settings != null ? tenant.value.settings[m.optional_key] : true;
            }

            if (m.children && m.children.length) {
                const children = m.children.filter((c) => {

                    if (user.value.read_only && c.disabled_read_only === true) {
                        return false;
                    }

                    if (c.optional) {
                        return tenant.value.settings != null ? tenant.value.settings[c.optional_key] : true;
                    }

                    return true;
                });

                m.children = children;
            }

            return true;
        });
    }

    const getTenantPublicMenuItems = () => {
        const tenantMenus = getMenus(publicNavMenuItems);

        tenantMenus.forEach(menu => {
            if (menu.children && menu.children.length) {
                if (!user.value.is_tenant_admin && !userIsAdmin.value) {
                    menu.children = menu.children.filter(c => !(!!c.admin));
                }
            }
        });

        return tenantMenus;
    }

    const getTenantAdminMenuItems = () => {
        let tenantMenus = getMenus(adminNavMenuItems);
        if (!user.value.is_feedback_manager) {
            tenantMenus = tenantMenus.filter(m => !m.feedbackManager);
        }
        if (user.value.is_tenant_admin) {
            return tenantMenus;
        }

        return tenantMenus.filter(m => !m.tenantAdmin);
    }

    return {
        getTenantTerm,
        publicMenusItems: getTenantPublicMenuItems(),
        getTenantAdminMenuItems,
    };
}